module.exports = __webpack_public_path__ + "static/img/img_2.2242c9c2.jpg";